export default "__VITE_ASSET__RA8gC7W___"